export { DeckRetiredTag, DeckRetiredTagProps } from './DeckRetiredTag';
